import React, { useContext } from 'react';
import Table from "../../../components/table/table";
import { DataContext } from '../../../App';
import { useTranslation } from 'react-i18next';

const Users = () => {
    const context = useContext(DataContext);
    const { t } = useTranslation();

    const userTable = {
        info: {
            url: "users",
            name: "User",
            header: [
                {
                    field: "displayName",
                    header: t("FullName"),
                    sortable: true,
                    type: "Text",
                    show: false,
                },
                {
                    field: "email",
                    header: t("Email"),
                    sortable: true,
                    type: "Text",
                    show: false,
                }
                // {
                //     field: "disabled",
                //     header: t("Status"),
                //     sortable: true,
                //     type: "Boolean",
                //     show: false,
                // },
            ],
            body: context.users
        },
        exportable: false,
        importable: false,
        filterType: "search"
    };

    return (
        <>

            <div className="w-full mt-10 py-1 table-user">
                <div className="content-table">
                <h1 className="admin-title">{t("Users")}</h1>
                    <div className="container-large table-wrapper mt-5">
                        <Table
                            info={userTable.info}
                            exportable={userTable.exportable}
                            importable={userTable.importable}
                            filterType={userTable.filterType}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Users;
